import React from "react"
import { EmptyStateLayout, LinkButton } from "@strapi/design-system"
import { Cross, Plus } from "@strapi/icons"

interface NoItemsProps {
  text: string
  addText: string
  addLink: string
  showAdd: boolean
}

const NoItems = ({ text, addText, addLink, showAdd }: NoItemsProps) => (
  <EmptyStateLayout
    icon={<Cross />}
    content={text}
    action={
      showAdd && (
        <LinkButton variant="secondary" startIcon={<Plus />} href={addLink} target="_self">
          {addText}
        </LinkButton>
      )
    }
  />
)

export default NoItems
